export interface LinkFlowState {
  progress: number;
  lastSeconds?: number;
}

/** Keep progress independent of zoom and route length; only elapsed time advances it. */
export function linkFlowArrow(points: Array<{x: number; y: number}>, seconds: number, scale: number, state: LinkFlowState):
  {x: number; y: number; dx: number; dy: number} | null {
  const zoom = Math.max(scale, 0.001);
  const lengths = points.slice(1).map((point, i) => Math.hypot(point.x - points[i].x, point.y - points[i].y));
  const total = lengths.reduce((sum, length) => sum + length, 0);
  const elapsed = state.lastSeconds == null ? 0 : Math.min(0.1, Math.max(0, seconds - state.lastSeconds));
  state.lastSeconds = seconds;
  if (!Number.isFinite(total) || !total) return null;
  state.progress = (state.progress + elapsed * 45 / (zoom * total)) % 1;
  if (total * zoom < 24) return null;
  let distance = state.progress * total;
  for (let i = 0; i < lengths.length; i++) {
    const length = lengths[i];
    if (!length) continue;
    if (distance <= length) {
      const dx = (points[i + 1].x - points[i].x) / length;
      const dy = (points[i + 1].y - points[i].y) / length;
      return {x: points[i].x + dx * distance, y: points[i].y + dy * distance, dx, dy};
    }
    distance -= length;
  }
  return null;
}
